export const SEND_MSG = 'SEND_MSG';
export const DIRECT_MSG = 'RECEIVED_MSG';